module.exports = __webpack_public_path__ + "static/iveta.05694c37.png";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/AboutPage/PeopleSection/iveta.png
// module id = 1001
// module chunks = 0